// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__BmWVf","col":"Table_col__3qVtq","fulfillmentStatus":"Table_fulfillmentStatus__3LKeq","emailCol":"Table_emailCol__16yjS"};